import { useDispatch } from 'react-redux';
import { CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE } from '../../../contants/ClaimsEnums';
import { getPreClaimsShipperConsigneeByShortNameEffect } from '../../../redux/Claims/PreClaims/PreClaimsEffects';
import { setAppLoader } from '../../../redux/common/CommonActions';
import FormInput from '../Inputs/FormInput';

const PreClaimsShipperConsigneeShortName = ({
  placeholder = 'Enter consignee short name',
  label = 'Consignee Short Name',
  rules = [],
  name,
  editMode,
  margin,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  dataTestId,
  onFetch = () => {},
  maxLength = 0,
}) => {
  const dispatch = useDispatch();
  const handleOnBlur = async (e) => {
    try {
      if (!e?.target?.value) {
        onFetch(CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.CLEAR);
      } else {
        dispatch(setAppLoader(true));
        const { data } = await getPreClaimsShipperConsigneeByShortNameEffect(e?.target?.value);
        dispatch(setAppLoader(false));
        if (data?.zip) {
          onFetch(CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.SUCCESS, data);
        } else {
          onFetch(CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.EMPTY);
        }
      }
    } catch {
      dispatch(setAppLoader(false));
      onFetch(CLAIMS_SHIPPER_CONSIGNEE_FETCH_ERROR_TYPE.ERROR);
    }
  };
  return (
    <FormInput
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      onBlur={handleOnBlur}
      maxLength={maxLength}
      dataTestId={dataTestId}
    />
  );
};

export default PreClaimsShipperConsigneeShortName;
